import React from "react";
import { useHistory } from "react-router-dom";

import { Button } from "react-bootstrap";

import AnonymousPageView from "../common/AnonymousPageView";

import styles from "./ssoFailure.module.scss";

import cleverStoryLogo from "../../../assets/images/logo/logo-cs.svg";

export default function SsoFailure() {
  const history = useHistory();

  return (
    <AnonymousPageView>
      <div className={styles.ssoFailureContainer}>
        <img className={styles.logo} src={cleverStoryLogo} alt="Cleverstory logo" />
        <h1 className={styles.title}>
          We are unable to grant you access to this service because one or more of
          your Single Sign-On login credentials is invalid. Please try again!
        </h1>
        <Button className={styles.signinButton} onClick={() => history.push("/login")}
          type="submit" variant="primary">
          Back to Login
        </Button>
      </div>
    </AnonymousPageView>
  );
}